import React from "react";

const RoofIcon = (props) => {
    return(
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="19.504" viewBox="0 0 28 19.504"><path d="M15.481 10.781l-11.407 8.095v6.876h23.852v-1.69l-12.226-8.675a.52.52 0 0 1-.219-.423zm1.038 2.037v1.882l13.481 9.562v-1.872zm.914-6.57l.886 1.252-16.319 11.576v-1.876z" transform="translate(-2 -6.248)" fill={props.fill} /></svg>
    )
}

export default RoofIcon;
